import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const event = useConnect('event.byId', {
    id: Number(match.params.eventId)
  })

  if (event.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      event={event}
      page="Subjects"
      title="What subjects does this event cover?"
      description={(
        <>
          <span className="font-semibold italic">TIP</span>: Choose as many subjects as apply, not just
          what's technically in your curriculum.
        </>
      )}
    >
      <Form
        user={user}
        event={event}
        navigation={(
          <Navigation v5={true} activeStep={7} steps={13}/>
        )}
        onPrevious={(newData) => history.push(Urls(event).SUMMARY)}
        onNext={(newData) => history.push(Urls(event).SLOTS)}
        onSkip={() => history.push(Urls(event).SLOTS)}
        onExit={() => history.push(Urls(event).EVENT_EDIT)}
      />
    </ParentLayout>
  );
};
